export enum ListCondition {
  And,
  Or,
  Not,
}
